import "core-js/modules/es6.regexp.replace";
export default (function (val) {
  var abc = parseFloat(val);
  return '$ ' + abc.toFixed(2).replace(/./g, function (c, i, a) {
    return i && c !== '.' && (a.length - i) % 3 === 0 ? ',' + c : c;
  });
});